import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/devilery-orders', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
  .post('/api/v1/devilery-orders', data)
  .then(response => Promise.resolve(response.data))
  .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/devilery-orders/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
    return httpClient
      .put(`/api/v1/devilery-orders/${id}`, data)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error.response.data))
}
  
export const destroy = id => {
    return httpClient
        .delete(`/api/v1/devilery-orders/${id}`)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const previewToPdf = id => {
    return httpClient
        .get(`/api/v1/devilery-orders/${id}/to-pdf`)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const invoiceDetail = id => {
    return httpClient
        .get(`/api/v1/devilery-orders/${id}/invoices`)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
  
export const employee = (Options = {}) => {
  return httpClient
    .get('/api/v1/devilery-orders/employees', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const invoice = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/devilery-orders/${id}/stock-out`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { 
    get,
    store,
    employee,
    invoice,
    find,
    update,
    destroy,
    previewToPdf,
    invoiceDetail
}